import React from 'react';

import {NotepadAvatar} from 'ccm/art/MedicalIcons';
import InfoCard from './InfoCard';

export default function TherapyCard(props) {
    return (
        <InfoCard
            color='blue'
            Avatar={NotepadAvatar}
            title='Therapy Progress'
            {...props}
        ></InfoCard>
    );
}
